import React, { useState, useCallback, useEffect } from "react";
import { Link } from "react-router-dom";
import css from "classnames";

function MenuLevel({
  content,
  level,
  openSubMenus,
  toggleSubMenu,
  toggleMobMenu,
}) {
  let contentArr = Object.values(content);
  return contentArr.map((item, i) => {
    if (item.showinmenu === false) return null;

    const menuKey = `${level}-${item.slug || item.uri || i}`;
    const hasChildren =
      (item.children && Object.keys(item.children).length > 0) ||
      (item.pagetype === "list" && item.filterInMenu);
    const isOpen = !!openSubMenus[menuKey];

    return (
      <div
        className={
          level === 0
            ? "header-mob--menu-list-item"
            : `header-mob--menu-submenu-item mob-level-${level}`
        }
        key={menuKey}
      >
        <div className="header-mob--menu-item-row">
          <Link
            to={`/${item.uri}`}
            state={{ preFilter: "" }}
            onClick={() => {
              if (
                item.filterInMenu === undefined &&
                item.children === undefined
              ) {
                toggleMobMenu();
              }
            }}
          >
            {item.title}
          </Link>
          {hasChildren && (
            <button
              className="header-mob--menu-toggle"
              onClick={() => toggleSubMenu(menuKey)}
              aria-expanded={isOpen}
              aria-label={
                isOpen
                  ? `${item.title} Untermenü schließen`
                  : `${item.title} Untermenü öffnen`
              }
            >
              <span
                className={css("header-mob--menu-chevron", {
                  "is-open": isOpen,
                })}
              />
            </button>
          )}
        </div>

        {hasChildren && (
          <div
            className={css("header-mob--menu-submenu", {
              "is-closed": !isOpen,
            })}
          >
            {item.pagetype === "list" && item.filterInMenu && (
              <>
                {item.filterInMenu.map((filterItem, j) => {
                  return (
                    <div
                      className={`header-mob--menu-submenu-item mob-level-${level}`}
                      key={j}
                    >
                      <Link
                        to={`/${item.uri}`}
                        state={{ preFilter: filterItem }}
                        onClick={() => {
                          toggleMobMenu();
                        }}
                      >
                        {filterItem}
                      </Link>
                    </div>
                  );
                })}
              </>
            )}
            {item.children && (
              <MenuLevel
                content={item.children}
                level={level + 1}
                openSubMenus={openSubMenus}
                toggleSubMenu={toggleSubMenu}
                toggleMobMenu={toggleMobMenu}
              />
            )}
          </div>
        )}
      </div>
    );
  });
}

function MobileMenu({ content, show, toggleMobMenu }) {
  const [openSubMenus, setOpenSubMenus] = useState({});

  const toggleSubMenu = useCallback((menuKey) => {
    setOpenSubMenus((prev) => ({ ...prev, [menuKey]: !prev[menuKey] }));
  }, []);

  // Reset submenus when menu closes
  useEffect(() => {
    if (!show) setOpenSubMenus({});
  }, [show]);

  // Scroll lock
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [show]);

  // Close on Escape
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && show) {
        toggleMobMenu();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [show, toggleMobMenu]);

  if (content) {
    let menuHTMLItems = (
      <MenuLevel
        content={content}
        level={0}
        openSubMenus={openSubMenus}
        toggleSubMenu={toggleSubMenu}
        toggleMobMenu={toggleMobMenu}
      />
    );
    return (
      <>
        <div
          className={css("header-mob--overlay", { "is-visible": show })}
          onClick={toggleMobMenu}
        />
        <nav
          className={css("header-mob--menu-list", { "is-open": show })}
          role="navigation"
          aria-label="Mobile Navigation"
          id="mobile-menu"
        >
          <div className="header-mob--menu-list-inner">{menuHTMLItems}</div>
        </nav>
      </>
    );
  }
  return null;
}

export default MobileMenu;
